<template>
  <div>
    <span class="text-primary ml-xs" :title="title">{{ title }}</span>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    screenName: {
      type: String,
      default: undefined,
    },
  },
  mounted() {
    if(this.screenName) document.title = this.screenName;
    else if (this.title) document.title = this.title;
  },
  updated() {
    if(this.screenName) document.title = this.screenName;
    else if (this.title) document.title = this.title;
  },
};
</script>
